import React, { useEffect, useRef, useState } from "react";
import { format, parse } from "date-fns";
import PageHeader from "../PageHeader";
import CreatableSelect from "react-select/creatable";
import Datetime from "react-datetime";
import "../../assets/scss/customInvoiceWrapper.scss";

import {
  ApproveCheckIcon,
  AttachmentIcon,
  BusinessBillIcon,
  ClockIcon,
  DotSpinner,
  DownloadIcon,
  EditIcon,
  EmailIcon,
  ExcelIcon,
  FilterCollapseIcon,
  FilterTwoIcon,
  GroupUsers,
  LoaderIcon,
  ViewIcon,
} from "../Icons";
import Select from "react-select";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Quill from "quill";
import "quill-better-table/dist/quill-better-table.css";
import TableModule from "quill-better-table";
import {
  Button,
  InputGroup,
  Modal,
  Form,
  Dropdown,
  Collapse,
  Spinner,
} from "react-bootstrap";
import { useFormik } from "formik";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import {
  customerFullName,
  customerTypeOptions,
  fetchActionsUtil,
  formatDate,
  getCustomerFirstAndLastName,
  paginationOptions,
  searchParamsToObject,
} from "../../utils/helpers";
import queryString from "query-string";
import { isEmpty, uniqBy } from "lodash";
import { useMutation, useQuery } from "react-query";
import { queryActions } from "../../utils/reactQueryActions";
import DateTime from "react-datetime";

import * as yup from "yup";

import { toast } from "react-toastify";
import useDebounce, {
  useLocalStorage,
  useQueryParams,
  useScrollTop,
} from "../../utils/hooks";
import ReactPaginate from "react-paginate";
import CachedIcon from "mdi-react/CachedIcon";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import RsDateRangePicker from "../utils/RsDateRangePicker";
import TableComponent from "../TableComponent";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import NoTableItem from "../utils/NoTableItem";
import FormSelectorModal from "./FormSelectorModal";
import { read, utils } from "xlsx";
import { FaUsers } from "react-icons/fa";
import moment from "moment";
import CustomInvoiceNumberInput from "../utils/CustomInvoiceNumberInput";
import SubscriptionEmailTemplateEditor from "./SubscriptionEmailTemplateEditor";
import AccountStatementEmailTemplate from "./AccountStatementEmailTemplate";
import PasswordResetEmailTemplateEditor from "./PasswordResetEmailTemplateEditor";
import UpdateAutoEmailsAndResendEditor from "./UpdateAutoEmailsAndResendEditor";
import CustomerSelector from "../utils/CustomerSelector";
import { Popover } from "react-tiny-popover";

// const SizeStyle = ReactQuill.import("attributors/style/size");
// SizeStyle.whitelist = ["12px", "14px", "16px", "18px", "24px"];
// ReactQuill.register(SizeStyle, true);

// const ColorStyle = ReactQuill.import("attributors/style/color");
// ReactQuill.register(ColorStyle, true);

const toolbarOptions = [
  ["bold", "italic", "underline", "strike"], // toggled buttons
  ["blockquote", "code-block"],

  [{ header: 1 }, { header: 2 }], // custom button values
  [{ list: "ordered" }, { list: "bullet" }],
  [{ script: "sub" }, { script: "super" }], // superscript/subscript
  [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
  [{ direction: "rtl" }], // text direction

  [{ size: ["small", false, "large", "huge"] }], // custom dropdown
  [{ header: [1, 2, 3, 4, 5, 6, false] }],

  [{ color: [] }, { background: [] }], // dropdown with defaults from theme
  [{ font: [] }],
  [{ align: [] }],
  ["link"],

  ["clean"], // remove formatting button
  ["undo", "redo"],

  [{ formula: true }], // math formula
  [{ syntax: true }], // syntax highlighting
  [{ mention: true }], // user/entity mentions
  [{ table: true }],
  [{ history: true }],
];
const recipientTypeOptions = [
  {
    value: "customers",
    label: "Customers",
    children: [{ value: "debtor", label: "Debtor" }],
  },
  // {
  //   value: "manually_selected_customers",
  //   label: "Manually Selected Customers",
  // },
  // { value: "customer_group", label: "Customer Group" },
  // { value: "customer_type", label: "Customer Type" },
  {
    value: "vendors",
    label: "Vendors",
    children: [{ value: "creditor", label: "Creditor" }],
  },
  // { value: "manually_selected_vendors", label: "Manually Selected Vendors" },
];

const emailTypeOptions = [
  {
    value: "creditor",
    label: "Creditor",
    parents: [{ value: "vendors", label: "Vendors" }],
  },
  {
    value: "debtor",
    label: "Debtor",
    parents: [{ value: "customers", label: "Customers" }],
  },
];

export function CreateAutomatedEmail({
  show,
  onclick,
  emailDetails,
  refetch,

  ...props
}) {
  const { backendUrl, token } = useAuth();

  const resendEmailMutation = useMutation(
    (payload) =>
      fetchActionsUtil(
        `${backendUrl}/api/customers/resend-auto-emails`,
        "POST",
        token,
        payload,
      ),
    {
      onSuccess: (data) => {
        toast.success(data.message || "Email resent successfully");
        refetch();
        onclick(false);
      },
      onError: (error) => {
        toast.error(error.message || "Failed to resend email");
      },
    },
  );
  function sendAndSaveEmail(emailData) {
    resendEmailMutation.mutate({
      id: emailDetails?.id,
      html: emailData.html,
      subject: emailData.subject,
      type: emailDetails?.emailType,
      isUpdateAndResend: true,
    });
  }
  return (
    <>
      <Modal
        show={show}
        size="xl"
        onHide={() => onclick(false)}
        style={{
          fontFamily:
            '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        }}
      >
        <Modal.Header
          closeButton
          style={{
            borderBottom: "1px solid #e5e7eb",
            padding: "1.5rem 2rem",
            background: "linear-gradient(to right, #f8fafc, #ffffff)",
          }}
        >
          <Modal.Title
            className="h5"
            style={{
              fontSize: "1.5rem",
              fontWeight: "600",
              color: "#1e293b",
              display: "flex",
              alignItems: "center",
              gap: "0.75rem",
            }}
          >
            {emailDetails?.type === "update"
              ? "Edit and Resend Email"
              : `Edit ${emailDetails?.title} Email Template`}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "2rem", backgroundColor: "#f9fafb" }}>
          <main className="">
            <div className="content">
              <div className="content-main">
                <div className="content-body">
                  <div className="row g-4">
                    {/* LEFT COLUMN - Email Content */}
                    <div className="col-md-12">
                      <div
                        style={{
                          backgroundColor: "white",

                          padding: "1.75rem",
                          boxShadow:
                            "0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)",
                          marginBottom: "1.5rem",
                        }}
                      >
                        {emailDetails?.type === "subscription" && (
                          <SubscriptionEmailTemplateEditor onOpen={onclick} />
                        )}
                        {emailDetails?.type === "accountStatement" && (
                          <AccountStatementEmailTemplate onOpen={onclick} />
                        )}

                        {emailDetails?.type === "password" && (
                          <PasswordResetEmailTemplateEditor onOpen={onclick} />
                        )}
                        {emailDetails?.type === "update" && (
                          <UpdateAutoEmailsAndResendEditor
                            content={emailDetails?.content || ""}
                            subject={emailDetails?.subject || ""}
                            onSubmit={sendAndSaveEmail}
                            isLoading={resendEmailMutation.isLoading}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </Modal.Body>
      </Modal>
    </>
  );
}

function EmailContent({ title, content, show, hide }) {
  return (
    <Modal show={show} onHide={() => hide(false)} size="xl">
      <Modal.Header closeButton>
        <Modal.Title className="h5">Mail</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>{title}</h4>
        <iframe
          srcDoc={content}
          className="w-100"
          style={{ minHeight: "50rem" }}
          title={title}
        />
      </Modal.Body>
    </Modal>
  );
}
function EmailAdressModal({ addressId, show, hide, group }) {
  async function getEmailAddress(url) {
    const res = await fetch(url, {
      method: "GET",
      credentials: "include",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
    });
    return await res.json();
  }

  const { backendUrl, token } = useAuth();
  const { data } = useQuery(["emailAddress", addressId], async () =>
    getEmailAddress(
      `${backendUrl}/api/customers/get-group-email-address/${addressId}`,
    ),
  );

  const tableHead = () => {
    return (
      <thead className="position-sticky top-0">
        <tr>
          <th>S/N</th>
          <th>Email</th>
        </tr>
      </thead>
    );
  };

  const tableData = (el, index) => {
    return (
      <>
        <td>{index + 1}</td>
        <td>{el}</td>
      </>
    );
  };

  return (
    <Modal show={show} onHide={() => hide(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title className="h5">Email Address</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="fw-bold mb-3">{group}</p>

        <div>
          <TableComponent
            responsive
            borderless
            striped
            tableHeadsFunction={tableHead}
            mainDataArray={data?.data?.Email.split(" , ") || []}
            className="product-table text-nowrap"
            tableDataRowFunction={tableData}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
}

function LogModal({ logData, close, open }) {
  const { backendUrl, token } = useAuth();
  const [filterParams, setFilterParams] = useState({
    q: "",
    status: "",
    page: 1,
    limit: 10,
    startDate: "",
    endDate: "",
  });

  const [resendEmailState, setResendEmailState] = useState({
    id: "",
    isLoading: false,
  });

  const debouncedFilterParams = useDebounce(filterParams, 500);

  const { data: logResponse = { data: [], total: 0 }, refetch } = useQuery(
    ["emailLog", logData?.id, debouncedFilterParams],
    () => {
      const queryString = Object.entries(debouncedFilterParams)
        .filter(([_, v]) => v !== "")
        .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
        .join("&");

      return fetchActionsUtil(
        `${backendUrl}/api/customers/get-schedule-emails-history/${
          logData?.id
        }${queryString ? "?" + queryString : ""}`,
        "GET",
        token,
      );
    },
    {
      // enabled: open && logData?.id,
      keepPreviousData: true,
    },
  );
  const resendEmailMutation = useMutation(
    (id) =>
      fetchActionsUtil(
        `${backendUrl}/api/customers/resend-auto-emails`,
        "POST",
        token,
        { id },
      ),
    {
      onSuccess: (data) => {
        toast.success(data.message || "Email resent successfully");
        refetch();
        setResendEmailState({
          id: "",
          isLoading: false,
        });
      },
      onError: (error) => {
        toast.error(error.message || "Failed to resend email");
        setResendEmailState({
          id: "",
          isLoading: false,
        });
      },
    },
  );
  //  I need a use Mutation for resending email here is the endpoint to call resend-single-scheduled-email only pass in the id as the payload use fetchActionUtils for the with useMutation

  const handleResendEmail = (id) => {
    if (!id) return;
    setResendEmailState({
      id,
      isLoading: true,
    });
    resendEmailMutation.mutate(id);
  };

  const handleStatusChange = (selected) => {
    setFilterParams({
      ...filterParams,
      status: selected?.value || "",
      page: 1,
    });
  };

  const handleSearchChange = (e) => {
    setFilterParams({
      ...filterParams,
      q: e.target.value,
      page: 1,
    });
  };

  const handleSearchQueryChange = (e) => {
    setFilterParams({
      ...filterParams,
      [e.target.name]: e.target.value,
      page: 1,
    });
  };

  const clearFilters = () => {
    setFilterParams({
      q: "",
      status: "",
      page: 1,
      limit: 10,
      startDate: "",
      endDate: "",
    });
  };

  const filterByDateRange = (date) => {
    if (date && date[0] && date[1]) {
      setFilterParams({
        ...filterParams,
        startDate: format(date[0], "yyyy-MM-dd"),
        endDate: format(date[1], "yyyy-MM-dd"),
        page: 1,
      });
    }
  };

  const clearDateRange = () => {
    setFilterParams({
      ...filterParams,
      startDate: "",
      endDate: "",
      page: 1,
    });
  };

  const statusOptions = [
    { value: "", label: "All" },
    { value: "success", label: "Success" },
    { value: "failed", label: "Failed" },
  ];

  const tableHead = () => {
    return (
      <thead>
        <tr>
          <th>S/N</th>
          <th>Action</th>
          <th>Date</th>
          <th>Status</th>
          <th>Resend Count</th>
          <th>Message</th>
        </tr>
      </thead>
    );
  };

  const displayTableData = (el, index) => {
    const startIndex = (filterParams.page - 1) * filterParams.limit;
    return (
      <>
        <td>{startIndex + index + 1}</td>
        <td>
          <Button
            size="sm"
            onClick={() => handleResendEmail(el?.id)}
            disabled={
              resendEmailState?.isLoading && resendEmailState?.id === el?.id
            }
          >
            {resendEmailState?.isLoading && resendEmailState?.id === el?.id
              ? "Resending"
              : "Resend"}
          </Button>
        </td>
        <td>
          {el.Post_Time
            ? formatDate(new Date(el.Post_Time), "dd MMM, yyyy hh:mm a")
            : "..."}
        </td>
        <td>
          {el.status === "success" ? (
            <span className="text-success">Success</span>
          ) : (
            <span className="text-danger">{el?.status}</span>
          )}
        </td>
        <td> {el?.resendCounter ? el?.resendCounter : "0"}</td>
        <td>{el.message}</td>
      </>
    );
  };

  return (
    <Modal
      show={open}
      onHide={() => close(false)}
      centered
      backdrop="static"
      size="lg"
      style={{ zIndex: 1050 }}
    >
      <Modal.Header closeButton>
        <Modal.Title as={"h6"}>
          Email Schedule Log{" "}
          <CachedIcon style={{ cursor: "pointer" }} onClick={refetch} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/* Filters Section */}
        <div
          className="mb-4 p-3"
          style={{ backgroundColor: "#f8f9fa", borderRadius: "6px" }}
        >
          <div className="row">
            {/* Search Input */}
            <div className="col-md-6 col-lg-3 mb-3">
              <label className="form-label">Search </label>
              <InputGroup>
                <InputGroup.Text>
                  <MagnifyIcon width={18} height={18} />
                </InputGroup.Text>
                <Form.Control
                  placeholder="Search..."
                  name="q"
                  value={filterParams.q}
                  onChange={handleSearchChange}
                />
              </InputGroup>
            </div>

            {/* Status Filter */}
            <div className="col-md-6 col-lg-3 mb-3">
              <label className="form-label">Status</label>
              <Select
                classNamePrefix="form-select"
                placeholder="All Status"
                isSearchable={false}
                isClearable
                options={statusOptions}
                value={statusOptions.find(
                  (el) => el.value === filterParams.status,
                )}
                onChange={handleStatusChange}
              />
            </div>

            {/* Date Range */}
            <div className="col-md-6 col-lg-4 mb-3">
              <label className="form-label">Date Range</label>
              <div className="position-relative" style={{ zIndex: 10001 }}>
                <RsDateRangePicker
                  value={
                    filterParams.startDate && filterParams.endDate
                      ? [
                          parse(
                            filterParams.startDate,
                            "yyyy-MM-dd",
                            new Date(),
                          ),
                          parse(filterParams.endDate, "yyyy-MM-dd", new Date()),
                        ]
                      : []
                  }
                  onClean={() => clearDateRange()}
                  onOk={(date) => filterByDateRange(date)}
                />
              </div>
            </div>

            {/* Reset Button */}
            <div className="col-md-6 col-lg-2 mb-3 d-flex align-items-end">
              <Button
                variant="outline-secondary"
                size="sm"
                onClick={clearFilters}
                className="w-100"
              >
                Reset Filters
              </Button>
            </div>
          </div>
        </div>

        {/* Table Section */}
        <div className="">
          {logResponse?.data && logResponse?.data?.log?.length > 0 ? (
            <TableComponent
              responsive
              borderless
              striped
              tableHeadsFunction={tableHead}
              mainDataArray={logResponse?.data?.log}
              tableDataRowFunction={displayTableData}
              className="product-table text-nowrap"
            />
          ) : (
            <NoTableItem queryParams={""} />
          )}
        </div>

        {/* Pagination Section */}
        {logResponse?.data && logResponse?.data?.log?.length > 0 && (
          <div className="d-flex justify-content-between px-3 align-items-center pagination">
            <div className="pagination_left">
              <p className="m-0 p-0">Show</p>
              <select
                value={filterParams.limit}
                name="limit"
                className="form-select "
                onChange={(e) => handleSearchQueryChange(e)}
              >
                <option value="10">10 rows</option>
                <option value="20">20 rows</option>
                <option value="30">30 rows</option>
                <option value="40">40 rows</option>
                <option value="50">50 rows</option>
                <option value="100">100 rows</option>{" "}
              </select>
            </div>

            <ReactPaginate
              {...paginationOptions}
              pageCount={Math.ceil(
                logResponse?.data?.count / filterParams.limit,
              )}
              marginPagesDisplayed={2}
              pageRangeDisplayed={0}
              onPageChange={({ selected }) => {
                document.body.scrollTop = document.documentElement.scrollTop = 0;
                setFilterParams({
                  ...filterParams,
                  page: selected + 1,
                });
              }}
              forcePage={filterParams.page - 1}
            />
          </div>
        )}
      </Modal.Body>
    </Modal>
  );
}

export default function AutomatedEmailNotification() {
  useScrollTop();
  const initialFilterParams = {
    q: "",
    startDate: "",
    endDate: "",
    customerName: "",
    customerId: "",
  };

  const [showFilter, setShowFilter] = useLocalStorage("showEmailFilter", true);
  const { backendUrl, token } = useAuth();
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [content, setContent] = useState("");
  const [title, setTitle] = useState("");
  const [showContentModal, setContentModal] = useState(false);
  const [showAddressModal, setShowEmailAddressModal] = useState(false);
  const [emailAddressesId] = useState("");
  const [recipientGroup] = useState("");
  const [emailDetails, setEmailDetails] = useState({});
  const [scheduleHistory, setScheduleHistory] = useState({});
  const [openScheduleHistoryModal, setOpenScheduleHistoryModal] = useState(
    false,
  );
  const [showItemsPopover, setShowItemsPopover] = useState(false);

  const [queryParams, setQueryParams] = useQueryParams({
    page: 1,
    limit: 40,
    ...initialFilterParams,
  });

  const [filterParams, setFilterParams] = useState({
    ...initialFilterParams,
    ...queryParams,
  });
  const [resendEmailState, setResendEmailState] = useState({
    id: "",
    isLoading: false,
  });

  const resendEmailMutation = useMutation(
    (id) =>
      fetchActionsUtil(
        `${backendUrl}/api/customers/resend-auto-emails`,
        "POST",
        token,
        { id },
      ),
    {
      onSuccess: (data) => {
        toast.success(data.message || "Email resent successfully");
        refetch();
        setResendEmailState({
          id: "",
          isLoading: false,
        });
      },
      onError: (error) => {
        toast.error(error.message || "Failed to resend email");
        setResendEmailState({
          id: "",
          isLoading: false,
        });
      },
    },
  );
  //  I need a use Mutation for resending email here is the endpoint to call resend-single-scheduled-email only pass in the id as the payload use fetchActionUtils for the with useMutation

  const handleResendEmail = (id) => {
    if (!id) return;
    setResendEmailState({
      id,
      isLoading: true,
    });
    resendEmailMutation.mutate(id);
  };

  const handleSelectedCustomer = (customer) => {
    setFilterParams({
      ...filterParams,
      customerId: customer.Cust_ID,
      customerName: customerFullName(customer),
    });
    setShowItemsPopover(false);
  };

  const fetchCompanDetails = async (query) => {
    const res = await fetch(
      `${backendUrl}/api/customers/get-email-notifications?${queryString.stringify(
        query,
      )}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
          ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
      },
    );

    const data = await res.json();

    return data;
  };

  const { data, refetch, isFetching, isSuccess } = useQuery(
    ["GET_AUTOMATED_EMAIL_CAMPAIGN", queryParams],
    () => fetchCompanDetails(queryParams),

    {
      enabled: true,
      keepPreviousData: true,
    },
  );

  const debouncedFilterParams = useDebounce(filterParams, 500);
  useEffect(() => {
    setQueryParams({
      ...queryParams,
      ...debouncedFilterParams,
    });
  }, [debouncedFilterParams, setQueryParams]);

  const handleFilterParamsChange = (e) => {
    setFilterParams({
      ...filterParams,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };

  const filterByDateRange = (date) => {
    setFilterParams({
      ...filterParams,
      startDate: format(date[0], "yyyy-MM-dd"),
      endDate: format(date[1], "yyyy-MM-dd"),
      enableDateRange: true,
    });
  };

  const clearDateRange = () => {
    setFilterParams({
      ...filterParams,
      startDate: "",
      endDate: "",
    });
  };
  const search = () => {
    setQueryParams({
      ...queryParams,
      ...filterParams,
    });
  };

  const reset = () => {
    setFilterParams(initialFilterParams);
    setQueryParams({
      ...queryParams,
      ...initialFilterParams,
    });
  };

  const handleSearchQueryChange = (e) => {
    setQueryParams({
      ...queryParams,
      [e.target.name]: e.target.value,
    });
  };

  const tableHead = () => {
    return (
      <thead className="position-sticky top-0">
        <tr>
          <th />
          <th>Title</th>
          <th>Customer</th>
          <th>Email</th>
          <th>Date</th>
        </tr>
      </thead>
    );
  };

  function parseViews(views) {
    return JSON.parse(views);
  }
  const tableData = (el, index) => {
    const content = parseViews(el?.Content || "{}");
    const customer = parseViews(el?.Customer || "{}");
    // const invoiceData = parseViews(el?.InvoiceData || "{}");

    return (
      <>
        <td>
          <Dropdown>
            <Dropdown.Toggle
              variant=""
              className="bg-white border-0"
              bsPrefix="print more"
            >
              <DotsVerticalIcon />
            </Dropdown.Toggle>
            <Dropdown.Menu
              popperConfig={{
                strategy: "fixed",
              }}
              renderOnMount
              className="dropdown-with-icons"
            >
              <Dropdown.Item
                as="button"
                onClick={() => {
                  setContent(content);
                  setTitle(el?.Title);
                  setContentModal(true);
                }}
              >
                <ViewIcon /> Open{" "}
              </Dropdown.Item>

              {["subscription", "accountStatement"].includes(el?.type) && (
                <Dropdown.Item
                  as="a"
                  href={`${backendUrl}/api/customers/get-auto-email-attachments?id=${
                    el?.id
                  }&type=${el?.type}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <ViewIcon />
                  View Attachment
                </Dropdown.Item>
              )}

              <Dropdown.Item
                as="button"
                onClick={() => {
                  setEmailDetails({
                    type: "update",
                    title: "Resend " + el?.Title,
                    content,
                    subject: el?.Title,
                    customer,
                    id: el?.id,
                    emailType: el?.type,
                  });
                  setShowEmailModal(true);
                }}
              >
                <EditIcon />
                <span> Edit & Resend</span>
              </Dropdown.Item>
              <Dropdown.Item
                as="button"
                onClick={() => {
                  setResendEmailState({
                    id: el.id,
                    isLoading: true,
                  });
                  handleResendEmail(el?.id);
                  // setTitle(emailData.subject);
                }}
              >
                <ClockIcon />
                <span> Resend</span>
              </Dropdown.Item>
            </Dropdown.Menu>{" "}
          </Dropdown>
        </td>
        <td>{el?.Title || ""}</td>
        <td>
          <span>{getCustomerFirstAndLastName(customer) || ""}</span>
        </td>

        <td>{formatDate(el.Email)}</td>

        <td>
          {"  "}
          {formatDate(el.Date)}
        </td>
      </>
    );
  };

  return (
    <>
      <EmailAdressModal
        show={showAddressModal}
        group={recipientGroup}
        hide={setShowEmailAddressModal}
        addressId={emailAddressesId}
      />

      <EmailContent
        content={content}
        show={showContentModal}
        title={title}
        hide={setContentModal}
      />

      {showEmailModal && (
        <CreateAutomatedEmail
          show={showEmailModal}
          onclick={setShowEmailModal}
          refetch={refetch}
          emailDetails={emailDetails}
        />
      )}

      {openScheduleHistoryModal && (
        <LogModal
          open={openScheduleHistoryModal}
          close={setOpenScheduleHistoryModal}
          logData={scheduleHistory}
        />
      )}

      <main className="inner-page-outlet  mt-3">
        {/* <PageHeader
          name="Scheduled Email Campaign"
          description="Send bulk Email to customers and vendors"
          icon={<EmailIcon />} */}

        {/* <CreateCustomersEmail /> */}
        <main className="cash-book">
          <div className="content">
            <div className="content-main">
              <div className={`filter-area ${showFilter ? "open" : "close"}`}>
                <div className="filter-header">
                  <h2>
                    <FilterTwoIcon /> Filters
                  </h2>

                  <Button
                    variant="white"
                    onClick={() => setShowFilter(!showFilter)}
                  >
                    <FilterCollapseIcon />
                  </Button>
                </div>
                <div className="filter-body">
                  <Form>
                    <div className="body">
                      <Form.Group className="mb-2-5">
                        <Form.Label>Search</Form.Label>{" "}
                        <InputGroup>
                          <Form.Control
                            name="q"
                            value={filterParams?.q}
                            placeholder="search title or email..."
                            onChange={(e) => handleFilterParamsChange(e)}
                            id="email-title-id"
                          />{" "}
                        </InputGroup>
                      </Form.Group>

                      <Form.Group className="mb-2-5">
                        <Form.Label>Customer ID</Form.Label>
                        <InputGroup>
                          <Form.Control
                            name="customerId"
                            placeholder="Enter Customer ID"
                            value={filterParams?.customerId}
                            onChange={(e) => handleFilterParamsChange(e)}
                          />
                          <Popover
                            isOpen={showItemsPopover}
                            onClickOutside={() => setShowItemsPopover(false)}
                            content={() => (
                              <CustomerSelector
                                handleSelectedCustomer={handleSelectedCustomer}
                                setShowCustomerSelector={setShowItemsPopover}
                              />
                            )}
                            position="bottom"
                          >
                            <InputGroup.Text
                              onClick={() =>
                                setShowItemsPopover(!showItemsPopover)
                              }
                            >
                              <MagnifyIcon />
                            </InputGroup.Text>
                          </Popover>
                        </InputGroup>
                      </Form.Group>

                      <Form.Group className="mb-2-5">
                        <Form.Label>Customer Name</Form.Label>
                        <Form.Control
                          name="customerName"
                          value={filterParams?.customerName}
                          placeholder="Enter Customer Name"
                          onChange={(e) => handleFilterParamsChange(e)}
                        />
                      </Form.Group>

                      <hr className="mt-3 mb-4" />
                      <Form.Group className="">
                        <Form.Label>Date Range</Form.Label>
                        <div className="position-relative">
                          <RsDateRangePicker
                            placement="topStart"
                            value={
                              filterParams.startDate && filterParams.endDate
                                ? [
                                    parse(
                                      filterParams.startDate,
                                      "yyyy-MM-dd",
                                      new Date(),
                                    ),
                                    parse(
                                      filterParams.endDate,
                                      "yyyy-MM-dd",
                                      new Date(),
                                    ),
                                  ]
                                : []
                            }
                            onClean={() => clearDateRange()}
                            onOk={(date) => filterByDateRange(date)}
                          />
                        </div>
                      </Form.Group>
                    </div>

                    <div className="buttons rounded">
                      <Button onClick={() => reset()} variant="white">
                        Reset
                      </Button>
                      <Button onClick={() => search()} variant="primary">
                        Search
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
              <div className="content-body">
                <header>
                  <h1>
                    {!showFilter && (
                      <button
                        onClick={() => setShowFilter(!showFilter)}
                        className="btn filter"
                      >
                        <FilterTwoIcon />
                      </button>
                    )}
                    Auto Generated Mails
                    <button
                      title="Refresh"
                      onClick={() => refetch()}
                      className="btn text-primary"
                    >
                      <CachedIcon />
                    </button>
                  </h1>
                  <div className="actions">
                    <Dropdown>
                      <Dropdown.Toggle
                        variant=""
                        className="btn print"
                        disabled={false}
                        bsPrefix=""
                      >
                        <EmailIcon /> Edit Email Templates
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        popperConfig={{
                          strategy: "fixed",
                        }}
                        renderOnMount
                        className="dropdown-with-icons"
                      >
                        <Dropdown.Item
                          as="button"
                          type="button"
                          onClick={() => {
                            setEmailDetails({
                              type: "accountStatement",
                              title: "Customer Statement of Account",
                            });
                            setShowEmailModal(true);
                          }}
                        >
                          Account Statement Template
                        </Dropdown.Item>
                        <Dropdown.Item
                          as="button"
                          type="button"
                          onClick={() => {
                            setEmailDetails({
                              type: "subscription",
                              title: "Subscription Renewal",
                            });
                            setShowEmailModal(true);
                          }}
                        >
                          Subscription Renewal Template
                        </Dropdown.Item>
                        <Dropdown.Item
                          as="button"
                          type="button"
                          onClick={() => {
                            setEmailDetails({
                              type: "password",
                              title: "Password Reset Email",
                            });
                            setShowEmailModal(true);
                          }}
                        >
                          Reset Password Template
                        </Dropdown.Item>
                      </Dropdown.Menu>{" "}
                    </Dropdown>
                  </div>
                </header>

                <div className=" px-md-4">
                  <TableComponent
                    responsive
                    borderless
                    striped
                    tableHeadsFunction={tableHead}
                    mainDataArray={data?.data || []}
                    className="product-table text-nowrap"
                    tableDataRowFunction={tableData}
                    // tableRowClick={(e, el) => manageTransaction(e, el)}
                  />

                  {!isFetching && isSuccess && isEmpty(data?.data) ? (
                    <NoTableItem queryParams={queryParams} />
                  ) : null}
                </div>

                <div className="d-flex justify-content-between px-3 align-items-center pagination">
                  <div className="pagination_left">
                    <p className="m-0 p-0">Show</p>
                    <select
                      value={queryParams.limit}
                      name="limit"
                      className="form-select "
                      onChange={(e) => handleSearchQueryChange(e)}
                    >
                      <option value="10">10 rows</option>
                      <option value="20">20 rows</option>
                      <option value="30">30 rows</option>
                      <option value="40">40 rows</option>
                      <option value="50">50 rows</option>
                      <option value="100">100 rows</option>{" "}
                    </select>
                  </div>

                  <ReactPaginate
                    {...paginationOptions}
                    pageCount={Math.ceil(data?.count / queryParams.limit)}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={0}
                    onPageChange={({ selected }) => {
                      document.body.scrollTop = document.documentElement.scrollTop = 0;
                      setQueryParams({
                        ...queryParams,
                        page: selected + 1,
                      });
                    }}
                    forcePage={queryParams.page - 1}
                  />
                </div>
              </div>
            </div>
          </div>
        </main>
      </main>
    </>
  );
}
